var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndefined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#D9DBE3",
    stroke: "#D9DBE3",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2575_11658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 46,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2575_11658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3424 48.7087L46.4089 69.715H46.3652C45.8868 71.6273 44.7257 73.2988 43.1005 74.4145C41.4754 75.5302 39.4984 76.0132 37.5419 75.7726C35.5853 75.5319 33.7843 74.5842 32.478 73.108C31.1717 71.6317 30.4502 69.7287 30.4494 67.7574C30.4499 67.1932 30.5085 66.6305 30.6242 66.0782L33.1937 54.74C31.8216 53.5394 30.7879 52.0002 30.1957 50.2758C29.6035 48.5514 29.4734 46.7019 29.8183 44.9116C30.1633 43.1213 30.9712 41.4525 32.1617 40.0716C33.3522 38.6906 34.8837 37.6456 36.6037 37.0407C38.3236 36.4358 40.1721 36.292 41.9649 36.6237C43.7578 36.9554 45.4324 37.7509 46.8221 38.9312C48.2119 40.1114 49.2681 41.6352 49.8858 43.3506C50.5034 45.0661 50.6608 46.9134 50.3424 48.7087Z",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4683 55.4738C46.5994 64.2448 48.1935 73.3816 46.7535 79.6269C46.6477 83.0314 46.8041 84.1401 46.8041 84.1401C46.8041 84.1401 40.4323 81.5845 24.4751 81.8766C14.0432 82.0699 6.80421 83.7169 6.16932 84.5611C6.16932 84.5611 6.12102 79.8547 6.16932 78.4699C4.98697 64.8061 5.2354 66.6394 2.9098 56.617C0.773003 55.5322 -0.942212 53.7674 -1.96568 51.6006C-2.98915 49.4338 -3.26272 46.988 -2.74329 44.6486C-2.22386 42.3092 -0.940949 40.2091 0.903365 38.679C2.74768 37.1489 5.04859 36.2758 7.44369 36.1973C7.44369 36.1973 34.8173 36.3376 41.1776 36.3445C43.7801 36.6823 46.171 37.9552 47.9042 39.9259C49.6374 41.8965 50.5946 44.4303 50.5973 47.0547C50.5973 50.3855 48.8445 53.4955 46.4729 55.4738",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0747 45.2193C28.0747 45.2193 28.8223 49.9763 29.4986 58.1953C30.3727 68.8296 31.7092 81.6169 31.7092 81.6169",
    stroke: "#4676FA",
    strokeWidth: 0.389746,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6816 38.788C31.7023 39.4436 30.4763 39.8876 28.6176 40.0164L28.1277 44.5549L26.3518 40.0233C25.947 40.0034 25.5306 39.9712 25.1028 39.9267C21.4384 39.5402 18.4319 38.4085 18.4089 37.3964C18.4066 37.3169 18.4231 37.2381 18.4572 37.1663L18.6136 22.5341L29.3054 22.7135L31.6425 38.4476H31.562C31.6326 38.5487 31.674 38.6673 31.6816 38.7903",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3579 36.5312C31.229 36.5013 31.0956 36.4691 30.9576 36.4323C21.4022 33.9227 21.9864 25.4967 21.9864 25.4967L29.9892 27.3116L31.3579 36.5312Z",
    fill: "#2047AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7689 30.1387C31.1197 30.7485 30.3177 31.1713 29.4479 31.3625C28.5759 31.5585 27.6674 31.518 26.8163 31.2452C24.4217 30.4723 21.0656 28.5745 19.2966 23.9164C15.8715 24.9677 13.3803 19.7897 15.462 18.3957C16.7456 17.5377 18.4892 18.4624 19.3978 19.4308C19.458 19.4948 19.514 19.5624 19.5658 19.6333C19.552 16.8223 16.3752 13.8618 17.9855 12.2723C26.4966 3.90611 31.3807 8.82339 32.6413 10.0333C33.1174 11.8529 34.3061 15.242 34.7938 18.1036C35.8036 24.0429 33.8391 28.1812 31.7666 30.1318L31.7689 30.1387ZM19.4093 19.44H19.3978C19.3794 19.417 19.3748 19.4147 19.4093 19.44Z",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8335 14.7778C16.8335 10.4822 20.3157 7 24.6113 7H27.7224C32.018 7 35.5002 10.4822 35.5002 14.7778V21C35.5002 26.1547 31.3215 30.3334 26.1668 30.3334C21.0122 30.3334 16.8335 26.1547 16.8335 21V14.7778Z",
    fill: "#4676FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5663 70.9959L16.0456 52.7983C17.0436 51.352 17.6603 49.6773 17.8387 47.9293C18.0171 46.1812 17.7514 44.4164 17.0661 42.7984C16.3809 41.1804 15.2983 39.7616 13.9186 38.6734C12.539 37.5852 10.907 36.8629 9.17394 36.5733C7.44083 36.2838 5.66267 36.4365 4.00427 37.0171C2.34586 37.5978 0.860858 38.5877 -0.313112 39.8951C-1.48708 41.2025 -2.31203 42.7851 -2.71151 44.4962C-3.11099 46.2073 -3.07207 47.9916 -2.59836 49.6836H-2.66047L6.06227 76.7467C6.12438 76.9652 6.19339 77.1814 6.2716 77.3931C6.66392 78.4371 7.26283 79.3913 8.03248 80.1985C8.80213 81.0057 9.72672 81.6494 10.7509 82.091C11.7751 82.5326 12.8778 82.7631 13.9932 82.7686C15.1085 82.7741 16.2135 82.5546 17.242 82.1231C18.2705 81.6917 19.2014 81.0572 19.979 80.2577C20.7566 79.4581 21.3649 78.5099 21.7676 77.4698C22.1702 76.4297 22.3589 75.319 22.3223 74.2043C22.2858 73.0895 22.0247 71.9936 21.5548 70.9821",
    fill: "#4676FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndefined);
export default __webpack_public_path__ + "static/media/undefined.35af77b60c50032fcd7465a9139d6fcf.svg";
export { ForwardRef as ReactComponent };